


























import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";

import { AvidiaStatementsList } from "@/shared/types";
import moment from "moment";
import { StatementsByYear as CurrentPageRoute } from "@/employee/route-names";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useAvidiaStatementsStore } from "@/employee/store/avidiaStatements";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class AvidiaStatements extends Vue {

  custodianSettingsStore = useCustodianSettingsStore();
  avidiaStatementsStore = useAvidiaStatementsStore();

  @Prop()
  year: number;

  @Watch("year")
  onYearChange (year: number) {
    this.avidiaStatementsStore.load(year);
  }

  formattedDate (statementDate: string): string {
    return moment(statementDate).format("MMM D, YYYY");
  }

  created () {
    this.custodianSettingsStore.getCustodianSettings();
    this.onYearChange(this.year);
  }

  get loaded () {
    return this.custodianSettingsStore.isLoaded && this.avidiaStatementsStore.loaded(this.year);
  }

  get loadedStatements (): AvidiaStatementsList | false {
    if (!this.loaded) {
      return false;
    }
    return this.avidiaStatementsStore.statements(this.year) as any;
  }

  get showNextYear () {
    return !!this.avidiaStatementsStore.nextYear(this.year);
  }

  get nextYearLabel () {
    return this.avidiaStatementsStore.nextYear(this.year);
  }

  get toNextYear () {
    return {
      name: CurrentPageRoute,
      query: {
        year: this.avidiaStatementsStore.nextYear(this.year)
      }
    };
  }

  get showPriorYear () {
    return !!this.avidiaStatementsStore.priorYear(this.year);
  }

  get priorYearLabel () {
    return this.avidiaStatementsStore.priorYear(this.year);
  }

  get toPriorYear () {
    return {
      name: CurrentPageRoute,
      query: {
        year: this.avidiaStatementsStore.priorYear(this.year)
      }
    };
  }
}
